/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ProductListsAuthorsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ProductListsAuthorsQuery = { productListsAuthors: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'ProductListsAuthorsResult', authorIds: Array<string> } };


export const ProductListsAuthorsDocument = gql`
    query ProductListsAuthors {
  productListsAuthors {
    ... on ProductListsAuthorsResult {
      authorIds
    }
  }
}
    `;

/**
 * __useProductListsAuthorsQuery__
 *
 * To run a query within a React component, call `useProductListsAuthorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductListsAuthorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductListsAuthorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductListsAuthorsQuery(baseOptions?: Apollo.QueryHookOptions<ProductListsAuthorsQuery, ProductListsAuthorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductListsAuthorsQuery, ProductListsAuthorsQueryVariables>(ProductListsAuthorsDocument, options);
      }
export function useProductListsAuthorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductListsAuthorsQuery, ProductListsAuthorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductListsAuthorsQuery, ProductListsAuthorsQueryVariables>(ProductListsAuthorsDocument, options);
        }
export function useProductListsAuthorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductListsAuthorsQuery, ProductListsAuthorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductListsAuthorsQuery, ProductListsAuthorsQueryVariables>(ProductListsAuthorsDocument, options);
        }
export type ProductListsAuthorsQueryHookResult = ReturnType<typeof useProductListsAuthorsQuery>;
export type ProductListsAuthorsLazyQueryHookResult = ReturnType<typeof useProductListsAuthorsLazyQuery>;
export type ProductListsAuthorsSuspenseQueryHookResult = ReturnType<typeof useProductListsAuthorsSuspenseQuery>;
export type ProductListsAuthorsQueryResult = Apollo.QueryResult<ProductListsAuthorsQuery, ProductListsAuthorsQueryVariables>;